export default {
  SET_PERMISSION_BY_USER(state, dataPermission) {
    state.dataPermission = dataPermission
  },
  CLEAR(state) {
    state.dataPermission = null
    localStorage.removeItem('dataPermission')
  },
}
